import React from "react";

const BookingSearch = ({
  value,
  onChange,
  onSearch,
  loading,
  hasBookingData,
  hasLogs,
  searchedBookingId,
}) => {
  return (
    <section className="logs-search-card">
      <div className="logs-search-header">
        <h2>Booking Logs</h2>
        <p>Search booking history and inspect each event in detail.</p>
      </div>

      <form
        className="logs-search-form"
        onSubmit={(event) => {
          event.preventDefault();
          onSearch();
        }}
      >
        <input
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Enter booking ID"
          className="logs-search-input"
        />
        <button type="submit" className="logs-search-button" disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
      </form>

      {!loading && searchedBookingId ? (
        <div
          className={`logs-search-status ${
            hasBookingData ? "success" : "error"
          }`}
        >
          {!hasBookingData
            ? `No booking found for ${searchedBookingId}`
            : hasLogs
              ? `Showing booking and event logs for ${searchedBookingId}`
              : `Booking found for ${searchedBookingId}. No event logs on this response.`}
        </div>
      ) : null}
    </section>
  );
};

export default BookingSearch;
